import {
  setupReturnCorrelationSchema,
  readCorrelatedSetupReturn,
  clearCorrelatedSetupReturn,
} from "components/payment/PaymentMethodSetup/setupReturn";
import * as yup from "yup";

const STORAGE_KEY = "moovs.profilePaymentMethodSetup";
export const profileSetupCorrelationSchema = setupReturnCorrelationSchema.shape({
  operatorId: yup.string().required(),
  payerId: yup.string().required(),
  linkedPassengerId: yup.string().nullable(),
});

export type ProfileSetupCorrelation = Omit<
  yup.InferType<typeof profileSetupCorrelationSchema>,
  "linkedPassengerId"
> & { linkedPassengerId?: string | null };
export type ProfileSetupReturn = ProfileSetupCorrelation & {
  clientSecret: string;
};

export const retainProfileSetup = (correlation: ProfileSetupCorrelation) => {
  // Do not persist the client secret, cardholder name, or card/billing data.
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(correlation));
};

export const readProfileSetupReturn = (
  operatorId: string,
  payerId: string,
  pathname: string,
  search: string
): ProfileSetupReturn | null => {
  const returned = readCorrelatedSetupReturn(
    STORAGE_KEY,
    profileSetupCorrelationSchema,
    pathname,
    search
  );
  return returned &&
    returned.operatorId === operatorId &&
    returned.payerId === payerId
    ? returned
    : null;
};

export const clearProfileSetup = (setupIntentId: string) =>
  clearCorrelatedSetupReturn(
    STORAGE_KEY, profileSetupCorrelationSchema, setupIntentId
  );

export { removeSetupReturnParams } from "components/payment/PaymentMethodSetup/setupReturn";
